<template>
    <div class="comment_table_box">
        <div class="lk-popup order-cancel" v-if="sendComment" style="transform: translateY(-50%);position: fixed;left: 0;right: 0;top: 50%;z-index: 999;margin:auto">
            <div class="title">
                <h1 style="display: inline-block;">Ответить на комментарий</h1>
                <button class="cross" @click="sendComment = null" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div>
                    <div class="comment_box">
                        <span>Ответ</span>
                        <textarea class="textarea" placeholder="Введите текст" v-model="text"></textarea>
                    </div>
                    <button class="menu_item_btn"  @click="saveData" >СОХРАНИТЬ</button>
                </div>
            </div>
        </div>
        <table class="comment_table" id="comment_table">
            <thead>
                <tr class="row">
                    <th>Дата</th>
                    <th>Гость</th>
                    <th>Имя</th>
                    <th>Текст</th>
                    <th>Рейтинг</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
              <tr class="row" v-for="(comment, index) in comments" :key="index">
                <td class="td">{{comment.created_at}}</td>
                <td class="td" v-if="comment.user_id !== 1">{{comment.user}}</td>
                <td class="td" v-else></td>
                <td class="td">{{comment.name}}</td>
                <td class="td">{{comment.text}}</td>
                <td class="td">{{comment.rating}}</td>
                <td class="td">
                  <button class="button answer" @click="sendComment = comment.id">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/answer.svg" alt="">
                  </button>
                </td>
                <td class="td">
                  <button class="button cancel" @click="deleteComment(comment)">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
                  </button>
                </td>
              </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
export default {
  name: 'zones',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      comments: [],
      sendComment: null,
      text: null,
      table: null
    }
  },
  created () {
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    saveData () {
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('comment_id', this.sendComment)
      formData.append('text', this.text)
      axios.post('https://lk.when-hungry.com/mobile/save-comment',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          this.table.destroy()
          this.loadRest()
          setTimeout(() => {
            alert('Ответ добавлен')
          }, 1)
          this.sendComment = null
          this.text = null
        }
      })
    },
    deleteComment (comment) {
      if (confirm('Вы действительно хотите удалить этот комментарий?')) {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('comment_id', comment.id)
        axios.post('https://lk.when-hungry.com/mobile/delete-comment',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(() => {
          this.table.destroy()
          this.comments.splice(this.comments.indexOf(comment), 1)
          setTimeout(() => {
            alert('Комментарий удален')
          }, 1)
        })
      }
    },
    loadRest () {
      axios.get('https://lk.when-hungry.com/mobile/get-comments?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
        this.comments = response.data
      })
    }
  },
  watch: {
    id (val, oldVal) {
      if (val !== oldVal) {
        this.loadRest()
      }
    },
    comments () {
      setTimeout(() => {
        this.table = $('#comment_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/comments.vue